export const StrankaVclanjena = {
  methods: {
    PreverjanjeClanstvo (prenosniParam) {
      if (prenosniParam.prenesenIzbranId !== '') {
        let param = ['idStranka=' + prenosniParam.prenesenIzbranId]
        this.clientAgent.postWsRequest(this,
          'klub/klubInfo?',
          param,
          prenosniParam,
          'SetPreverjanjeClanstvo',
          'ErrPreverjanjeClanstvo')
      }
    },
    SetPreverjanjeClanstvo (podatki, prenosniParam) {
      let podatkiStrankaKlub = podatki.data
      let podatkiStrankaKlubPridobivanje = true
      let vmesnik = prenosniParam.vmesnik
      let nalaganje = false
      vmesnik.PridobiStrankaVclanjena(podatkiStrankaKlub, prenosniParam, podatkiStrankaKlubPridobivanje, nalaganje)
    },
    ErrPreverjanjeClanstvo (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Klub/StrankaVclanjena.js